import request from '../utils/request'
import baseUrl from './baseUrl'

export const verification = data =>
	request({
		url: baseUrl + '/verification/selectForBack',
		method: 'POST',
		data
	})
export const addVerification = data =>
	request({
		url: baseUrl + '/verification/add',
		method: 'POST',
		data
	})
export const delVerification = data =>
	request({
		url: baseUrl + '/verification/deleteById',
		method: 'POST',
		data
	})